/**
 * Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
 */

/**
 * @author Igor Suleimanov <ihar@taotesting.com>
 */

import setNotificationHandler from 'ui/component/notification';

document.addEventListener('DOMContentLoaded', () => {
    setNotificationHandler('.btn-notification');
});
